var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpinionsDarkTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 767.74 489.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cac0d9;}.cls-2{fill:#b8cce4;}.cls-3{fill:#b333f6;}.cls-4{fill:#01aff0;}.cls-5{fill:#10a5dd;}.cls-6{fill:#16a2d8;}.cls-7{fill:#2eabdd;}.cls-8{fill:#12a9e5;}.cls-9{fill:#57badc;}.cls-10{fill:#e0f6f9;}.cls-11{fill:#5cb8d7;}.cls-12{fill:#49b4da;}.cls-13{fill:#49b3dd;}.cls-14{fill:#eaf9fd;}.cls-15{fill:#0babe7;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "opinions-dark-theme") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M925.43,338.3l9-32.6h-6.61c-32.81,0-65.63-.26-98.44.12-15.06.17-26.05-10.58-25.7-25.65,0.66-28.47.19-57,.19-85.45,0-14.33,9.68-24.05,23.93-24.06q86,0,171.9-.06c10.92,0,18.33,4.9,22.82,14.49a17.54,17.54,0,0,1,1.33,7.2q0.13,45,.05,89.95c0,13.63-8.89,23.67-22.35,23.2-10.8-.38-19.93,2.53-29,7.81-13.2,7.65-26.84,14.55-40.3,21.74C930.34,336,928.45,336.83,925.43,338.3Z",
    transform: "translate(-256.13 -140.35)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.8,351.78c-1.06-8.54-2-16.23-3-23.9-0.57-4.58-1.51-9.15-1.64-13.74-0.11-3.75-2.38-4.91-5.09-6.39-25.35-13.84-42.44-34.51-47.86-63-4.88-25.61,3.07-48.29,20-68.06s38.65-30.22,63.52-34.74c20-3.63,39.58-.88,58.53,6.45,13.64,5.28,25.88,12.84,36,23.34,17.62,18.22,27.5,39.84,25.38,65.57-1.31,15.93-7.31,30.29-17,43.32-9.16,12.27-20.82,21.31-34,28.38a97.54,97.54,0,0,1-39.24,11.62c-7.37.54-14.84-.24-22.19,0.36-2.58.21-5.39,2.36-7.38,4.34-8.07,8-15.85,16.35-23.75,24.56C588.71,350.34,588.16,350.69,586.8,351.78Z",
    transform: "translate(-256.13 -140.35)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M760.22,630.24H500.65c1.44-11.56,1.61-22.9,4.5-33.5a231.06,231.06,0,0,1,14.34-37.83c6.31-13.35,15.9-24.61,27.06-34.35a146.44,146.44,0,0,1,13.63-10.5c1.06-.72,3.78-0.44,4.81.45,15.26,13.08,32.93,20.37,52.73,23.26,16,2.34,31.51.17,46.55-5a92.36,92.36,0,0,0,31.44-18.25c1.18-1,4.34-1.58,5.39-.78,6.41,4.87,13,9.71,18.57,15.45a139.51,139.51,0,0,1,39.2,87.12C759.21,620.88,759.75,625.43,760.22,630.24Z",
    transform: "translate(-256.13 -140.35)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M326.77,331.84c-5.21-4.14-10.47-8.24-15.64-12.43-8.11-6.58-16.17-13.23-24.25-19.85q0-.4-0.09-0.8a23.28,23.28,0,0,0-4.63-1c-6.66-.12-13.33-0.18-20,0-3.18.09-4.39-.85-4.38-4.2,0.09-36.66,0-73.32.14-110,0-1.3,1.23-2.6,1.89-3.9q85.07,0,170.13-.06c1.64,0,3.27-1.22,4.91-1.87h2l2.86,2,0,5.92a38.78,38.78,0,0,0-.85,5.75q-0.08,50,0,99.91c0,6.37,0,6.37-6.59,6.37H333.84c-0.76,1.86-2.15,3.71-2.19,5.59-0.22,9.65-.1,19.3-0.1,29.16Z",
    transform: "translate(-256.13 -140.35)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317,584.68c1.09-10.28,1.38-20,3.32-29.44a154.7,154.7,0,0,1,8.84-29.43c5.19-12.15,11.35-24,20.82-33.64,7.43-7.52,15.32-14.57,22.82-22,3.54-3.52,5.8-3.71,10.2-.25,15.54,12.22,32.92,19.95,53.12,22.05,23.68,2.47,44.9-3,64.75-15.31,4.3-2.67,8.18-6,12.45-8.73,1-.64,3.33-0.7,4.12,0,8.86,8,17.8,15.89,26.16,24.37,4.39,4.45,7.67,10,10.87,14.27-9.83,9.85-19.92,18.79-28.58,29a111.84,111.84,0,0,0-20,33.58c-0.8,2.15-2,4.14-2.83,6.28-3.58,9.3-3.56,9.31-13.48,9.31H317Z",
    transform: "translate(-256.13 -140.35)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M942.5,584.68h-5.15q-85.74,0-171.48.11c-4.07,0-5.86-1.24-7-5-7.71-25.42-22.81-46-42.16-63.75-1.82-1.66-3.59-3.59-5.75-4.61-4.91-2.33-4.32-5-1.65-8.81a146.51,146.51,0,0,1,33.61-34.43c1.77-1.3,3.26-1.87,5.79.22,12.24,10.12,25.86,17.73,41.58,21.32,28.68,6.53,55.33,2.14,79.87-14.19,3.41-2.27,6.4-5.16,9.83-7.38a5.06,5.06,0,0,1,4.5-.18,124,124,0,0,1,31.12,29.83c11.26,15.07,18.83,31.82,23.64,49.84A101.78,101.78,0,0,1,942.5,584.68Z",
    transform: "translate(-256.13 -140.35)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M890.84,392.17c-0.33,41.3-33.48,75.11-73.42,76.17-46.11,1.22-79.68-34.55-79.46-76.65,0.22-41.87,34-77.35,79.11-75.78C857.45,317.31,889.64,349.31,890.84,392.17Z",
    transform: "translate(-256.13 -140.35)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M446.35,467.68c-43.55,1.9-76.59-35.89-76.19-75.55,0.43-42.66,32.67-76.3,77.55-76.29,39.76,0,76.25,33.91,75.28,78.86C522.17,433,487.28,470.48,446.35,467.68Z",
    transform: "translate(-256.13 -140.35)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M706.84,437.52c-0.37,44-34.7,77.82-78.08,76.78-42.11-1-74.39-33.36-74.64-75.9-0.25-43.22,33.25-76,75-76.51C673.25,361.36,705.66,395.54,706.84,437.52Z",
    transform: "translate(-256.13 -140.35)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M333.84,297.69h98.41c6.59,0,6.59,0,6.59-6.37q0-50,0-99.91a38.65,38.65,0,0,1,.85-5.75q0.41,8.53.82,17.06,0,1,0,1.94,0,2,0,4.06,0,7,0,13.94,0,10,0,20.05,0,1,0,1.94,0,2,0,4.06,0,7,0,13.94,0,10,0,20.05,0,1,0,1.95l-0.62,11.13-0.26,2.81-5.84.85-100.06,0Z",
    transform: "translate(-256.13 -140.35)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.82,179.66c-0.66,1.3-1.89,2.6-1.89,3.9-0.1,36.66,0,73.32-.14,110,0,3.36,1.2,4.29,4.38,4.2,6.66-.19,13.33-0.12,20,0a23.34,23.34,0,0,1,4.63,1l-1,.73c-8.48,0-17,.18-25.43.06-1.41,0-2.8-1.19-4.19-1.84q0-4.53-.07-9.05,0-50.47,0-100.94,0-3,0-6.05,0-1,0-1.93l0.79-1.91-0.12-.22,3,0.24Z",
    transform: "translate(-256.13 -140.35)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M436.84,177.72h-2l-169.14-.11a3.45,3.45,0,0,0,.14-0.91l169.53-.05a11.68,11.68,0,0,1,1.48.18Q436.86,177.28,436.84,177.72Z",
    transform: "translate(-256.13 -140.35)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M333.84,297.69l-0.07,1.74,0.12,0.43-0.89.82c0.33,10.72.68,21.45,1,32.17a27.6,27.6,0,0,1-.31,3.4c-1.2-.17-2.67,0-3.54-0.6a21.8,21.8,0,0,1-3.36-3.81l4.78,0.59c0-9.86-.12-19.51.1-29.16C331.7,301.4,333.08,299.55,333.84,297.69Z",
    transform: "translate(-256.13 -140.35)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M440.55,202.71q-0.41-8.53-.82-17.06,0-3,0-5.92l0.21-2.12Z",
    transform: "translate(-256.13 -140.35)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M440.55,242.71q0-10,0-20.05Q440.55,232.69,440.55,242.71Z",
    transform: "translate(-256.13 -140.35)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M440.55,282.71q0-10,0-20.05Q440.55,272.69,440.55,282.71Z",
    transform: "translate(-256.13 -140.35)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M265.86,176.71a3.45,3.45,0,0,1-.14.91l-5.87.22-3-.24C259.51,174.09,262.7,175.59,265.86,176.71Z",
    transform: "translate(-256.13 -140.35)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M439.94,295.79l0.62-11.13Z",
    transform: "translate(-256.13 -140.35)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M256.13,288.65q0,4.53.07,9.05Q256.17,293.18,256.13,288.65Z",
    transform: "translate(-256.13 -140.35)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M439.91,177.61l-0.21,2.12-2.86-2q0-.44,0-0.88l2,0,1,0.81Z",
    transform: "translate(-256.13 -140.35)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M256.13,181.65q0,3,0,6.05Q256.13,184.68,256.13,181.65Z",
    transform: "translate(-256.13 -140.35)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M433.83,299.45l5.84-.85Z",
    transform: "translate(-256.13 -140.35)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M440.55,208.72q0-2,0-4.06Q440.55,206.69,440.55,208.72Z",
    transform: "translate(-256.13 -140.35)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M440.55,248.72q0-2,0-4.06Q440.55,246.69,440.55,248.72Z",
    transform: "translate(-256.13 -140.35)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M256.93,177.81l-0.79,1.91Z",
    transform: "translate(-256.13 -140.35)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M439.85,177.67l-1-.81Z",
    transform: "translate(-256.13 -140.35)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M285.82,299.48l1-.73q0,0.4.09,0.8Z",
    transform: "translate(-256.13 -140.35)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M333,300.68l0.89-.82Z",
    transform: "translate(-256.13 -140.35)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M259.85,177.83l5.87-.22,169.14,0.11c-1.64.65-3.27,1.87-4.91,1.87q-85.06.14-170.13,0.06Q259.83,178.75,259.85,177.83Z",
    transform: "translate(-256.13 -140.35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpinionsDarkTheme);
export default __webpack_public_path__ + "static/media/opinions-dark-theme.914a93bf033d2f05723b354a3739350d.svg";
export { ForwardRef as ReactComponent };